import React from "react";
import { Outlet } from "react-router";

import { PricingProvider } from "../../contexts/PricingContext";

/** Monta o PricingProvider apenas no módulo de tabela de preços. */
export default function PricingLayout() {
  return (
    <PricingProvider>
      <Outlet />
    </PricingProvider>
  );
}
